import React from 'react';
import { MapPin } from 'lucide-react';
import { Reveal } from './hammer/reveal';

const STATES = [
  'Florida',
  'Georgia',
  'Texas',
  'North Carolina',
  'Wisconsin',
  'Virginia',
];

// Render the strip twice back-to-back so the CSS marquee animation
// (translate 0 → -50%) creates a seamless, endless loop.
function Strip({ ariaHidden = false }) {
  return (
    <div
      className="flex items-center gap-10 sm:gap-14 shrink-0 pr-10 sm:pr-14"
      aria-hidden={ariaHidden || undefined}
    >
      {STATES.map((state) => (
        <div
          key={state}
          className="flex items-center gap-2.5 shrink-0"
        >
          <MapPin className="w-3.5 h-3.5 text-cyan-300/80 shrink-0" />
          <span className="font-tech text-white/85 text-xs sm:text-sm uppercase tracking-[0.22em] whitespace-nowrap">
            {state}
          </span>
        </div>
      ))}
    </div>
  );
}

export default function TrustBar() {
  return (
    <section
      aria-label="Trusted by marine contractors"
      data-testid="trust-bar"
      className="relative bg-black border-y border-white/5 overflow-hidden py-6 sm:py-7"
    >
      {/* Centered title */}
      <Reveal>
        <div className="text-center px-5">
          <span className="font-tech text-cyan-300 text-[10px] sm:text-[11px] uppercase tracking-[0.28em]">
            Trusted by Marine Contractors in:
          </span>
        </div>
      </Reveal>

      {/* Full-bleed scrolling marquee — masked at edges for a soft fade */}
      <Reveal delay={0.15} y={14}>
        <div
          className="relative w-full overflow-hidden mt-4 sm:mt-5"
          style={{
            maskImage:
              'linear-gradient(90deg, transparent 0%, #000 6%, #000 94%, transparent 100%)',
            WebkitMaskImage:
              'linear-gradient(90deg, transparent 0%, #000 6%, #000 94%, transparent 100%)',
          }}
        >
          <div className="flex marquee-track">
            <Strip />
            <Strip ariaHidden />
          </div>
        </div>
      </Reveal>
    </section>
  );
}
